import moment from 'moment'
import { Moment } from 'moment'

import { dateToString } from 'modules/core/lib/dates'

export interface UnassignedShiftParam {
  start_at: string
  end_at: string
  notes?: string | null
  work_area_id?: string | number | null
  location_id?: string | number | null
  extra_hours?: boolean | null
  default_shift_id?: number | null
  default_shift_title?: string | null
  color: string | null
  counter: number
  job_catalog_roles_ids: number[]
  overnight_shift: boolean
  all_company: boolean
  teams_ids_visibilities: number[]
  locations_ids_visibilities: number[]
}

const buildUnassignedShiftParameters = (
  startTime: moment.Moment,
  endTime: moment.Moment,
  extraHours: boolean | null,
  notes: string | null,
  locationId: string | number | null,
  workAreaId: string | number | null,
  defaultShiftId: number | null,
  defaultShiftTitle: string | null,
  color: string | null,
  counter: number,
  jobCatalogRolesIds: number[],
  overnightShift: boolean,
  allCompany: boolean,
  teamsIdsVisibilities: number[],
  locationsIdsVisibilities: number[]
): UnassignedShiftParam[] => {
  const endDateTime = overnightShift ? moment(endTime.add(1, 'days').toDate()) : endTime

  const startAt = dateToString(startTime, 'ui_short_with_time')
  const endAt = dateToString(endDateTime, 'ui_short_with_time')

  const attributes: UnassignedShiftParam = {
    start_at: startAt,
    end_at: endAt,
    extra_hours: extraHours,
    notes,
    location_id: locationId,
    work_area_id: workAreaId,
    default_shift_id: defaultShiftId,
    default_shift_title: defaultShiftTitle,
    color,
    counter: counter,
    job_catalog_roles_ids: jobCatalogRolesIds,
    overnight_shift: overnightShift,
    all_company: allCompany,
    teams_ids_visibilities: teamsIdsVisibilities,
    locations_ids_visibilities: locationsIdsVisibilities,
  }

  return [{ ...attributes }]
}

const buildAddUnassignedShiftsParameters = ({
  date,
  unparsedStartTime,
  unparsedEndTime,
  defaultShiftId,
  defaultShiftTitle,
  extraHours,
  notes,
  locationId,
  workAreaId,
  color,
  counter,
  jobCatalogRolesIds,
  overnightShift,
  allCompany,
  teamsIdsVisibilities,
  locationsIdsVisibilities,
}: {
  date: Moment
  unparsedStartTime: string | null | undefined
  unparsedEndTime: string | null | undefined
  defaultShiftId: number | null
  defaultShiftTitle: string | null
  extraHours: boolean | null
  notes: string | null
  locationId: string | number | null
  workAreaId: string | number | null
  color: string | null
  counter: number
  jobCatalogRolesIds: number[]
  overnightShift: boolean
  allCompany: boolean
  teamsIdsVisibilities: number
  locationsIdsVisibilities: number
}): UnassignedShiftParam[] => {
  if (!unparsedStartTime || !unparsedEndTime) return []

  const dateString = dateToString(date, 'backend')
  const startTime = moment(dateString + ' ' + unparsedStartTime)
  const endTime = moment(dateString + ' ' + unparsedEndTime)

  if (!startTime || !startTime.isValid()) return []

  if (!endTime || !endTime.isValid()) return []

  return buildUnassignedShiftParameters(
    startTime,
    endTime,
    extraHours,
    notes,
    locationId,
    workAreaId,
    defaultShiftId,
    defaultShiftTitle,
    color,
    counter,
    jobCatalogRolesIds,
    overnightShift,
    !allCompany ? false : allCompany,
    !teamsIdsVisibilities || allCompany ? [] : [teamsIdsVisibilities],
    !locationsIdsVisibilities || allCompany ? [] : [locationsIdsVisibilities]
  )
}

export default buildAddUnassignedShiftsParameters
